import { FormInstance } from "antd";
import { RefObject } from "react";
import { Debug } from "./debug";
import dayjs from "dayjs";
import { checkEmpty, getJsonFromStr } from "./stringutil";
import { convertTempFtoC } from "@/components/layout/input/inputFunction";
import { clearTimelineData } from "@/components/layout/list/defaultType";
import { getLastCheckIndex, RoastingCheckCount } from "@/components/layout/inputCols/roastingCols";

export const convertProfiletoForm = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  fileType: string,
  value: string | undefined,
  compare?: boolean,
) => {
  const setValues =
    fileType === "text/csv" ? convertProfileCSVtoForm(value, compare) : convertProfileJSONtoForm(value, compare);
  if (compare) {
    return setValues;
  } else {
    form?.current?.setFieldsValue(setValues);
  }
};
const convertProfileCSVtoForm = (value: string | undefined, compare?: boolean) => {
  const result: Record<string, any> = { ...clearTimelineData };
  let check_head = false;
  const info = { date: "", unit: "C", start: 0, startStr: "", time: "" };
  const header: Record<string, number> = {};
  const roasting_chart_log: Record<number, { bean: number; air: number }> = {};
  if (value !== undefined) {
    const csv_arr = value.split(/\r\n|\n/gi);
    const utcOffset = dayjs().utcOffset() * 60000;
    // Debug(csv_arr);
    csv_arr.forEach((temp) => {
      const temp_arr = temp.split(/\t/gi);
      if (!check_head) {
        if (temp_arr.some((item) => item === "Event")) {
          temp_arr.forEach((item, index) => {
            header[item] = index;
          });
          check_head = true;
        } else {
          temp_arr.forEach((item) => {
            if (item.indexOf("Date:") === 0) {
              info.date = dayjs(item.substring("Date:".length), "DD.MM.YYYY").format("YYYY-MM-DD");
            } else if (item.indexOf("Unit:") === 0) {
              info.unit = item.substring("Unit:".length);
            } else if (item.indexOf("CHARGE:") === 0) {
              info.startStr = dayjs(0).format("YYYY-MM-DD HH:mm:ss").substring(0, 14);
              const temp_start = dayjs(info.startStr + item.substring("CHARGE:".length), "YYYY-MM-DD HH:mm:ss");
              Debug(temp_start);
              info.start = temp_start.valueOf();
            } else if (item.indexOf("Time:") === 0) {
              info.time = item.substring("Time:".length) + ":00";
            }
          });
        }
      } else {
        const term = dayjs(info.startStr + temp_arr[header["Time1"]], "YYYY-MM-DD HH:mm:ss").valueOf() - info.start;
        const event = temp_arr[header["Event"]];

        const bean = convertTemp(info.unit, Number(temp_arr[header["BT"]]), compare);
        const air = convertTemp(info.unit, Number(temp_arr[header["ET"]]), compare);
        if (checkEmpty(event)) {
          const log_key = Object.keys(roasting_chart_log)
            .map((item) => Number(item))
            .sort();
          if (checkEmpty(log_key)) {
            if (checkEmpty(temp_arr[header["Time2"]])) {
              result["pre_heating_start_term"] = dayjs(Math.abs(term)).add(-utcOffset);
              result["pre_heating_start_bean"] = bean;
              result["pre_heating_start_air"] = air;
            }
            roasting_chart_log[term] = { bean, air };
          } else {
            const last_term = Number(log_key[log_key.length - 1]);
            // Debug(last_term, term);
            if (term >= last_term + 30000) {
            }
            roasting_chart_log[term] = { bean, air };
          }
        } else {
          const temp_term = dayjs(term).add(-utcOffset);
          const dayjs_term = compare ? temp_term.valueOf() : temp_term;
          switch (event) {
            case "Charge":
              result["roasting_start_bean"] = bean;
              result["roasting_start_air"] = air;
              break;
            case "TP":
              result["roasting_turning_term"] = dayjs_term;
              result["roasting_turning_bean"] = bean;
              result["roasting_turning_air"] = air;
              break;
            case "Dry End":
              result["roasting_dried_term"] = dayjs_term;
              result["roasting_dried_bean"] = bean;
              result["roasting_dried_air"] = air;
              break;
            case "FCs":
              result["roasting_first_start_term"] = dayjs_term;
              result["roasting_first_start_bean"] = bean;
              result["roasting_first_start_air"] = air;
              break;
            case "FCe":
              result["roasting_first_end_term"] = dayjs_term;
              result["roasting_first_end_bean"] = bean;
              result["roasting_first_end_air"] = air;
              break;
            case "SCs":
              result["roasting_second_start_term"] = dayjs_term;
              result["roasting_second_start_bean"] = bean;
              result["roasting_second_start_air"] = air;
              break;
            case "SCe":
              result["roasting_second_end_term"] = dayjs_term;
              result["roasting_second_end_bean"] = bean;
              result["roasting_second_end_air"] = air;
              break;
            case "Drop":
              result["roasting_end_term"] = dayjs_term;
              result["roasting_end_bean"] = bean;
              result["roasting_end_air"] = air;
              break;
          }
        }
      }
    });

    Debug(info.date, info.time, info.unit, info, header);
  }
  result["roasting_start_time"] =
    !checkEmpty(info.date) && !checkEmpty(info.time) ? dayjs(info.date + " " + info.time) : undefined;
  if (Object.keys(roasting_chart_log).length > 0) {
    result["roasting_chart_log"] = JSON.stringify(roasting_chart_log);
  } else {
    result["roasting_chart_log"] = undefined;
  }

  return result;
};
const convertProfileJSONtoForm = (value: string | undefined, compare?: boolean) => {
  const change_value = value
    ? value
        .replace(/(?<!\\)'([^'\\]*(?:\\.[^'\\]*)*)'/g, '"$1"')
        .replace(/\bTrue\b/g, "true")
        .replace(/\bFalse\b/g, "false")
        .replace(/\bNone\b/g, "null")
    : "";
  // Debug(change_value);
  const result: Record<string, any> = { ...clearTimelineData };
  const roasting_chart_log: Record<number, { bean: number; air: number }> = {};
  let data: Record<string, any> = {};
  try {
    data = value ? JSON.parse(change_value) : {};
  } catch (e) {
    Debug(e);
  }
  if (!checkEmpty(data)) {
    const timex_arr = data.timex;
    const timeindex = data.timeindex;
    const startTime = timex_arr[timeindex[0]];
    const computed = data.computed;
    const computedTime: number[] = [];
    const tempMode = data.mode === "F" ? "F" : "C";
    const startDateTime =
      data.roastisodate && data.roasttime && data.roasttzoffset !== undefined
        ? dayjs(data.roastisodate + "T" + data.roasttime + "Z").add(data.roasttzoffset * 1000)
        : undefined;

    const utcOffset = dayjs().utcOffset() * 60000;
    if (computed) {
      const shiftTime = 0;
      result["roasting_start_bean"] = convertTemp(tempMode, computed.CHARGE_BT, compare);
      result["roasting_start_air"] = convertTemp(tempMode, computed.CHARGE_ET, compare);
      if (computed.TP_time !== undefined) {
        result["roasting_turning_term"] = dayjs((computed.TP_time - shiftTime) * 1000).add(-utcOffset);
        result["roasting_turning_bean"] = convertTemp(tempMode, computed.TP_BT, compare);
        result["roasting_turning_air"] = convertTemp(tempMode, computed.TP_ET, compare);
        computedTime.push(Math.floor(computed.TP_time + startTime));
      }
      if (computed.DRY_time !== undefined) {
        result["roasting_dried_term"] = dayjs((computed.DRY_time - shiftTime) * 1000).add(-utcOffset);
        result["roasting_dried_bean"] = convertTemp(tempMode, computed.DRY_BT, compare);
        result["roasting_dried_air"] = convertTemp(tempMode, computed.DRY_ET, compare);
        computedTime.push(Math.floor(computed.DRY_time + startTime));
      }
      if (computed.FCs_time !== undefined) {
        result["roasting_first_start_term"] = dayjs((computed.FCs_time - shiftTime) * 1000).add(-utcOffset);
        result["roasting_first_start_bean"] = convertTemp(tempMode, computed.FCs_BT, compare);
        result["roasting_first_start_air"] = convertTemp(tempMode, computed.FCs_ET, compare);
        computedTime.push(Math.floor(computed.FCs_time + startTime));
      }
      if (computed.FCe_time !== undefined) {
        result["roasting_first_end_term"] = dayjs((computed.FCe_time - shiftTime) * 1000).add(-utcOffset);
        result["roasting_first_end_bean"] = convertTemp(tempMode, computed.FCe_BT, compare);
        result["roasting_first_end_air"] = convertTemp(tempMode, computed.FCe_ET, compare);
        computedTime.push(Math.floor(computed.FCe_time + startTime));
      }
      if (computed.SCs_time !== undefined) {
        result["roasting_second_start_term"] = dayjs((computed.SCs_time - shiftTime) * 1000).add(-utcOffset);
        result["roasting_second_start_bean"] = convertTemp(tempMode, computed.SCs_BT, compare);
        result["roasting_second_start_air"] = convertTemp(tempMode, computed.SCs_ET, compare);
        computedTime.push(Math.floor(computed.SCs_time + startTime));
      }
      if (computed.SCe_time !== undefined) {
        result["roasting_second_end_term"] = dayjs((computed.SCe_time - -shiftTime) * 1000).add(-utcOffset);
        result["roasting_second_end_bean"] = convertTemp(tempMode, computed.SCe_BT, compare);
        result["roasting_second_end_air"] = convertTemp(tempMode, computed.SCe_ET, compare);
        computedTime.push(Math.floor(computed.SCe_time + startTime));
      }
      if (computed.DROP_time !== undefined) {
        result["roasting_end_term"] = dayjs((computed.DROP_time - shiftTime) * 1000).add(-utcOffset);
        result["roasting_end_bean"] = convertTemp(tempMode, computed.DROP_BT, compare);
        result["roasting_end_air"] = convertTemp(tempMode, computed.DROP_ET, compare);
        computedTime.push(Math.floor(computed.DROP_time + startTime));
      }
    }
    timex_arr.forEach((timex: number, index: number) => {
      const check_time = Math.floor(timex);
      const term = Math.floor(timex - startTime) * 1000;
      const air = convertTemp(tempMode, data.temp1[index], index === 0 && timeindex[0] !== 0 ? compare : false);
      const bean = convertTemp(tempMode, data.temp2[index], index === 0 && timeindex[0] !== 0 ? compare : false);
      if (air > 0 && bean > 0) {
        let check_index = -1;
        timeindex.some((item: number, t_index: number) => {
          if (item !== 0 && item === index) {
            check_index = index;
            return true;
          } else {
            return false;
          }
        });
        if (check_index !== -1 || computedTime.includes(check_time)) {
          // Debug(check_index, check_time, bean, air);
          //switch()
        } else {
          if (index === 0 && timeindex[0] !== 0) {
            result["pre_heating_start_term"] = dayjs(0 * 1000).add(-utcOffset + Math.ceil(startTime) * 1000);
            result["pre_heating_start_bean"] = bean;
            result["pre_heating_start_air"] = air;
          } else {
            roasting_chart_log[term] = { bean, air };
          }
        }
      }
    });
    Debug(timeindex, data);
    result["roasting_start_time"] = startDateTime;
    if (compare) {
      [
        "roasting_turning_term",
        "roasting_dried_term",
        "roasting_first_start_term",
        "roasting_first_end_term",
        "roasting_second_start_term",
        "roasting_second_end_term",
        "roasting_end_term",
        "pre_heating_start_term",
      ].forEach((item) => {
        if (result[item] !== undefined) {
          result[item] = dayjs(result[item]).add(utcOffset).valueOf();
        }
      });
    }
  }

  if (Object.keys(roasting_chart_log).length > 0) {
    Debug(roasting_chart_log);
    result["roasting_chart_log"] = JSON.stringify(roasting_chart_log);
  } else {
    result["roasting_chart_log"] = undefined;
  }
  return result;
};
const convertTemp = (mode: string, temp: number, compare?: boolean) => {
  return Math.round((mode === "C" ? Number(temp) : convertTempFtoC(Number(temp), 10)) * 100) / (compare ? 1 : 100);
};
export const logTempInputCheck = (form: FormInstance<any> | undefined) => {
  if (form) {
    const getFields = [
      "timeline_chart_log_temp_term",
      "roasting_chart_log",
      "roasting_start_bean",
      "roasting_turning_term",
      "roasting_turning_bean",
      "roasting_dried_bean",
      // "roasting_dried_term",
      "roasting_first_start_term",
      "roasting_first_end_term",
      "roasting_second_start_term",
      "roasting_second_end_term",
      "roasting_end_term",
    ];
    const getValues = form.getFieldsValue(getFields);
    const log = getJsonFromStr(getValues["roasting_chart_log"]) ?? {};
    if (log) {
      const end_term_dayjs =
        getValues["roasting_first_start_term"] ??
        getValues["roasting_first_end_term"] ??
        getValues["roasting_second_start_term"] ??
        getValues["roasting_second_end_term"] ??
        getValues["roasting_end_term"];
      const start_term_dayjs = getValues["roasting_turning_term"] ?? undefined;
      const utcOffset = dayjs().utcOffset() * 60000;
      const start_term = start_term_dayjs ? dayjs(start_term_dayjs).add(utcOffset).valueOf() : 0;
      const turning = !checkEmpty(start_term_dayjs);
      const end_term = end_term_dayjs ? dayjs(end_term_dayjs).add(utcOffset).valueOf() : undefined;
      // const logKeys = Object.keys(log).map((value) => Number(value));
      const temp_term = (getValues["timeline_chart_log_temp_term"] as number) ?? 10;
      const dried_bean = getValues["roasting_dried_bean"];
      // Debug(turning, start_term, end_term, logKeys, log);
      if (end_term) {
        const checkTerm: Record<number, any> = {};
        let check_bean = turning ? getValues["roasting_turning_bean"] : getValues["roasting_start_bean"];
        let check_bean_unit = Math.floor(check_bean / temp_term) * temp_term;
        let check_bean_low = check_bean_unit;
        let check_bean_high = check_bean_unit + temp_term;
        // Debug(check_bean, check_bean_unit, check_bean_low, check_bean_high);
        Object.entries(log).forEach(([logStr, values]) => {
          const logTerm = Number(logStr);
          let change_check = false;
          if (logTerm > start_term && logTerm < end_term) {
            const bean = values ? (values as any)["bean"] : undefined;
            if (bean) {
              if (bean >= check_bean_high) {
                check_bean = check_bean_high;
                change_check = true;
              } else if (bean <= check_bean_low) {
                check_bean = check_bean_low;
                change_check = true;
              }
            }
            if (change_check) {
              if (!dried_bean || (dried_bean && (dried_bean - 1 > bean || dried_bean + 1 < bean))) {
                checkTerm[logTerm] = values;
              }
              check_bean_unit = Math.floor(check_bean / temp_term) * temp_term;
              check_bean_low = check_bean_unit - temp_term;
              check_bean_high = check_bean_unit + temp_term;
              // Debug(check_bean_unit, check_bean_low, check_bean_high);
            }
          }
        });
        Debug(checkTerm);
        const lastIndex = getLastCheckIndex(form);
        if (!checkEmpty(checkTerm)) {
          const setValues: Record<string, any> = {};
          Object.entries(checkTerm).forEach(([logStr, values], index) => {
            const i = lastIndex + index;
            if (i <= RoastingCheckCount) {
              const key = "roasting_check" + i;
              const logTerm = Number(logStr);
              setValues[key + "_term"] = dayjs(logTerm).add(-utcOffset);
              setValues[key + "_bean"] = values["bean"];
              setValues[key + "_air"] = values["air"];
            }
          });
          if (!checkEmpty(setValues)) {
            if (checkEmpty(getValues["timeline_chart_log_temp_term"])) {
              setValues["timeline_chart_log_temp_term"] = 10;
            }
            form.setFieldsValue(setValues);
          }
        }
      }
    }
  }
};
